import { FlowConsumerContextEnergy as FlowContext } from '../../context';
import { energyTypeIncludes } from '../../shared/helpers';
import { EnergyType } from '../../shared/types';

export const shouldSkipWhenNoGas = (context: FlowContext): boolean => {
  const { energyType } = context;

  if (energyType) {
    return !energyTypeIncludes(energyType, EnergyType.Gas);
  }

  return true;
};
